import * as types from './mutation-types'

export default {
  [types.SHOW_MENU] (state) {
    state.menuVisible = true
  },
  [types.HIDE_MENU] (state) {
    state.menuVisible = false
  },
  [types.SHOW_LOADING_BAR] (state) {
    state.loading = true
  },
  [types.HIDE_LOADING_BAR] (state) {
    state.loading = false
  },
  [types.SET_TOKEN] (state, token) {
    state.token = token
  },
  [types.SET_USER] (state, user) {
    state.user = user
  },
  [types.SHOW_ERROR] (state, error) {
    if (error) {
      state.error = error
    }
    state.errorVisible = true
  },
  [types.HIDE_ERROR] (state) {
    state.errorVisible = false
  },
  [types.SET_PAGE_TITLE] (state, title) {
    state.pageTitle = title
  }
}



// WEBPACK FOOTER //
// ./src/store/mutations.js